<template>
  <div class="courseItem">
    <div class="box">
      <div class="left">
        <img
          :src="list.cover"
          alt=""
        >
      </div>
      <div class="right">
        <div class="title" :title="list.title">{{list.title}}</div>
        <div class="teacher">
          <img src="../../assets/course/teacher.png" />主讲人：{{list.teacher}} <img src="../../assets/course/num.png" />{{list.joinedNum}}人已学
        </div>
        <div
          class="time"
          v-if="list.joined&&isLogin==0"
        >
          <div class="bart">
            <div class="rate">
              <p :style="{width:list.finishedPercentage}"></p>
            </div>
            <span>{{list.finishedPercentage}}</span>
          </div>
          <p v-if="list.finishedPercentage=='100%'" class="total" style="margin-top:12px">恭喜你！课程已学完！</p>
          <p v-else class="total" style="margin-top:12px">目前已完成 <span>{{list.finishedTask}}</span>个课时, 加油啊！</p>
        </div>
        <div
          class="teaBtn"
          v-if="this.isLogin==0"
        >
          <template v-if="list.joined">
              <span
                v-if="list.finishedPercentage=='0%'"
                @click="$emit('tostudy',list.id)"
              >开始学习</span>
              <span
                v-else-if="list.finishedPercentage=='100%'"
                @click="$emit('tostudy',list.id)"
              >完成学习</span>
              <span
                v-else
                @click="$emit('tostudy',list.id)"
              >继续学习</span>
          </template>
          <span
            v-else
            @click="$emit('signup',list.id)"
          >立即参加</span>
        </div>
        <div
          class="teaBtn"
          v-else
          @click="$emit('logup',isLogin)"
        >
          立即参加
        </div>
        <div
          class="Collect"
          @click="$emit('tocollect',isLogin)"
        >
          <template v-if="isLogin==0">
            <img
              v-if="list.collected"
              src="../../assets/course/collect1.png"
              alt=""
            >
            <img
              v-else
              src="../../assets/course/collect.png"
              alt=""
            >
          </template>
          <template v-else>
            <img
              src="../../assets/course/collect.png"
              alt=""
            >
          </template>
          <template v-if="isLogin==0">
            <span v-if="list.collected">已收藏</span>
            <span v-else>收藏</span>
          </template>
          <template v-else>
            <span>收藏</span>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "courseItem",
  props: {
    list: Object,
    taskId: [String, Number],
  },
  data() {
    return {};
  },
  created() {
    // this.isLogin = localStorage.getItem("isLogin");
  },
  //   watch:{

  //   },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    toRealLecture(id) {
      window.open(id);
    },
  },
};
</script>

<style lang="stylus" scoped>
.courseItem {
  .box {
    height: 290px;
    width: 100%;
    background: #fff;
    display: flex;

    .left {
      width: 511px;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      padding: 20px 20px 30px 37px;
      position: relative;
      flex: 1;

      .title {
        font-size: 24px;
        color: #333;
        width: 561px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          color: #f0cd48;
        }
      }

      .teacher {
        font-size: 14px;
        color: #999;
        margin-top: 20px;
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;

          &:nth-child(2) {
            margin-left: 50px;
          }
        }
      }

      .time {
        overflow: hidden;

        .bart {
          display: flex;
          align-items: center;
          margin-top: 50px;
          height: 12px;

          .rate {
            width: 515px;
            background: #ddd;
            height: 100%;

            p {
              background: #1d9857;
              height: 100%;
            }
          }

          span {
            width: 30px;
            font-weight: bold;
            font-size: 14px;
            letter-spacing: 0px;
            color: #1d9857;
            margin-left: 20px;
          }
        }

        .total {
          width: 190px;
          height: 14px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;

          span {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0px;
            color: #666666;
          }
        }
      }

      .teaBtn {
        position: absolute;
        bottom: 44px;
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #f0cd48;
        color: #333;
        font-size: 16px;
        cursor: pointer;
        // border-radius: 3px;
        span{
          width: 140px;
          height: 40px;
          display:block;
          text-align center;
          line-height 40px;
        }
      }

      .Collect {
        width: 70px;
        height: 30px;
        text-align: center;
        position: absolute;
        top: 20px;
        right: 20px;
        background: #eee;
        line-height: 30px;

        img {
          width: 14px;
          height: 14px;
          margin-top: -3px;
          border-raduis: 3px;
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
